
import React from "react";
import { Control } from "react-hook-form";
import { 
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { useTranslation } from "react-i18next";
import { formatDateForInput } from "@/utils/dateHelpers";

interface DateFieldProps {
  control: Control<any>;
  name: string;
  label: string;
  placeholder?: string;
  required?: boolean;
}

const DateField: React.FC<DateFieldProps> = ({ 
  control, 
  name, 
  label, 
  placeholder,
  required = false 
}) => {
  const { t } = useTranslation();

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className="flex flex-col">
          <FormLabel className="text-sm font-medium">
            {label} {required && '*'}
          </FormLabel>
          <FormControl>
            <Input
              type="date"
              placeholder={placeholder}
              className="h-11 md:h-10 text-base md:text-sm"
              value={formatDateForInput(field.value)}
              onChange={(e) => {
                console.log('Native date input changed:', e.target.value);
                field.onChange(e.target.value);
              }}
              max={new Date(new Date().setFullYear(new Date().getFullYear() - 16)).toISOString().split('T')[0]}
              min={new Date(new Date().setFullYear(new Date().getFullYear() - 100)).toISOString().split('T')[0]}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default DateField;
